import React from "react";
import Login from "../components/Login";
import Nav from "../components/Nav";

function LoginPage() {
  return (
    <div>
      <Nav/>
      <Login />
    </div>
  );
}

export default LoginPage;
